import { useEffect, useState } from "react";

const useScreenWidth = () => {
  // clientWidth is the layout viewport width — always zoom-immune and never
  // affected by visual-viewport scale changes (no transient ScreenTooSmall).
  // It also updates correctly in landscape without needing scale division.
  const getWidth = () => document.documentElement.clientWidth;

  const [screenWidth, setScreenWidth] = useState<number>(getWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(getWidth());

    // On orientationchange, read dimensions after the viewport has settled.
    // WKWebView may not update clientWidth until ~100–150ms after the event;
    // waiting 200ms guarantees we read the correct landscape value.
    let orientationTimer: ReturnType<typeof setTimeout>;
    const handleOrientationChange = () => {
      clearTimeout(orientationTimer);
      orientationTimer = setTimeout(() => setScreenWidth(getWidth()), 200);
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleOrientationChange);
    return () => {
      clearTimeout(orientationTimer);
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleOrientationChange);
    };
  }, []);

  const mobileBreakpoint = 425;
  const tabletBreakpoint = 768;
  const laptopBreakpoint = 1024;
  const largeLaptopBreakpoint = 1280;
  const desktopBreakpoint = 1440;
  const fullHDBreakpoint = 1920;
  const twoKBreakpoint = 2560;
  const fourKBreakpoint = 3840;
  const fiveKBreakpoint = 5120;

  return {
    screenWidth,
    mobileBreakpoint,
    tabletBreakpoint,
    laptopBreakpoint,
    largeLaptopBreakpoint,
    desktopBreakpoint,
    fullHDBreakpoint,
    twoKBreakpoint,
    fourKBreakpoint,
    fiveKBreakpoint,
  };
};

export default useScreenWidth;
